import { Component, OnChanges, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog, MatDialogRef } from '@angular/material/dialog'

import { InspService } from '../services/inspections/insp.service';
import { DialogInspection } from '../dialog/inspeccions/dialog.component.insp';
import { ListService } from '../list.service';
import { saveAs } from 'file-saver';

import { IInspection, IInspectionResponse } from './insp.interfaces';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';

import { MatSidenav } from '@angular/material/sidenav';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StripHtmlPipe } from '../pipes/stripHTMLpipe';

@Component({
  selector: 'mcrit-gestio-inspeccions',
  templateUrl: './insp.component.html',
  styleUrls: ['./insp.component.css'],
  providers: [StripHtmlPipe, InspService, ListService]
})
export class InspectionsComponent implements OnInit, OnDestroy {
  public showAsyncProgress: boolean = false;
  public inspectionsData: IInspectionResponse;
  public userInfo: any = {};
  
  private activeFilters: any = {};
  private currentOrdering: any = {};
  private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number = 0;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  private unsubscriber : Subject<void> = new Subject<void>();
  public showFilters: boolean = true;
  public export: boolean = false;
  public orderingParameters: any;

  private inspModel: IInspection = {
      'plate': 'NEW',
      'date_last_inspection': null,
      'inspection_expiry_date': null,
      'inspection_result': null,
      'inspection_certificate_number': ''
  };
  public error: string = '';
  public showDialog: boolean = false;
  public editInspectionData: IInspection;

  public exportar(){this.export=true;this.requestRowsToParent();};

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public addInspection(): void {
    this.editInspectionData = Object.assign( {}, this.inspModel, { id : 'NEW' } );
    let dialogFactRef=this.dialog.open(DialogInspection, {disableClose: true, height: '450px', data: {dades: this.editInspectionData, user: this.userInfo} })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editInspectionData = results;
      this.addOrUpdate();
    });
  }

  public editInspection(inspection: IInspection): void {
    this.editInspectionData = Object.assign( {}, this.inspModel, inspection );
    let dialogFactRef=this.dialog.open(DialogInspection, {height: '450px', data: {dades: this.editInspectionData, user: this.userInfo} })

    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editInspectionData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;

    if (this.editInspectionData.plate === 'NEW') {
      this.inspService.create(this.editInspectionData)
        .subscribe(newContacte => {console.log("S'ha creat l'element");this.router.navigate(['inspections']);});
    } else {
      this.inspService.update(<number> this.editInspectionData.plate, this.editInspectionData)
        .subscribe(updatedContacte => {console.log("S'han desat les dades");this.router.navigate(['inspections']);});
        //Actualitza la llista amb les modificacions
        let updateItem = this.inspectionsData.rows.find(item => item.plate == this.editInspectionData.plate);
        let index = this.inspectionsData.rows.indexOf(updateItem);
        this.inspectionsData.rows[index] = this.editInspectionData;
    }
  }

  public gotoPage(page: number): void {
    this.listInspService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
  }

  public computeActiveFilters($event){
    if(this.currentOrdering.length == 0)['nom'].map(item => this.currentOrdering[item] = this.orderingCycle[1]);
    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listInspService.currentPage * this.listInspService.rowsPerPage;
    this.requestRowsToParent();
   }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listInspService.currentPage * this.listInspService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listInspService.rowsPerPage - 1, this.inspectionsData.registers);
  }

  private requestRowsToParent(): void {
    this.inspService.getList(
      this.listInspService.rowsPerPage, //Limit
      this.listInspService.currentPage*this.listInspService.rowsPerPage, //Skip
      this.activeFilters //FILTRE DE LES INSPECCIONS QUE ES MOSTREN A INICI
      ,{}//Conds a aplicar. Per defecte LIKE %%
      ,this.currentOrdering //ORDRE DE LES INSPECCIONS QUE ES MOSTREN A INICI
      ,this.export
    ).subscribe(
      data => {
        if(!this.export){this.inspectionsData = data;this.computeDisplayedRows();}
        else{
          var csvData = this.convertToCSV(data.rows);
          var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
          saveAs(file, "export.csv");
        }
      },
      error => console.log(error)
    );
  }

  public requestPrevious(): void {
     this.listInspService.currentPage = Math.max(0, this.listInspService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public requestNext(): void {
     this.listInspService.currentPage = this.listInspService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public setRowPerPage(rowsPerPage: number) {
     this.listInspService.rowsPerPage = rowsPerPage;
     this.requestRowsToParent();
  }

  public inspectionFilters: Array<any>
  public ordreCamps: Array<any>
  public tableFields: Array<any>

  constructor(public striphtml:StripHtmlPipe, public tokenStorage: TokenStorageService, public listInspService: ListService, public dialog:MatDialog, private inspService: InspService, private router: Router, private route: ActivatedRoute) {
  this.userInfo = this.tokenStorage.getUser();}

  ngOnInit() {
    this.ordreCamps = ['plate'];

    this.tableFields = [
      ['plate', 'Plate'],
      ['inspection_expiry_date', 'Next inspection'],
      ['date_last_inspection', 'Last inspection'],
      ['inspection_result', 'Resultats'],
      ['inspection_certificate_number', 'Certificate Number']
    ];

    this.inspectionFilters = [
    {
      inputs: []
    },
    {
      inputs: [
        {
          name: 'text',
          type: 'text',
          values: [
              {
                text: 'Plate',//Text a mostrar label
                name: 'plate',//Camp de la base de dades
                autocomplete: 'plate',//Crida per obtenir els valors si autocomplete
                value: this.listInspService.getSearchValues('text')//valor a mostrar
              },
              {
                text: 'Certificate Number',
                name: 'inspection_certificate_number',
                autocomplete: 'inspection_certificate_number',
                value: this.listInspService.getSearchValues('text')
              },
              {
                text: 'Next inspection',
                name: 'inspection_expiry_date',
                value: this.listInspService.getSearchValues('text')
              }
          ]
        }
      ]
    }
  ];

  this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    ['plate'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);
 
    const id = this.route.snapshot.paramMap.get('id');

    if (id) {
      this.computeActiveFilters({ plate: id });
    } else {
      this.computeActiveFilters({});
    }

    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
      this.unsubscriber.next();
      this.unsubscriber.complete();
  }

  go(lloc, id){this.router.navigate([lloc, id]);}

}
